import 'globals';
import highlightText from '@brianmcallister/highlight-text';

(function (window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        const searchPlugin = document.querySelector('.flowpack-searchplugin-search');

        if (searchPlugin) {
            /** @type {NodeList<HTMLDivElement>} */
            const searchItems = searchPlugin.querySelectorAll('.search-item');
            /** @type {NodeList<HTMLDivElement>} */
            const mediaTitleItems = searchPlugin.querySelectorAll('.mediathek-item-title');
            /** @type {HTMLInputElement} */
            const searchInput = searchPlugin.querySelector('input[name=search]');

            if (searchItems && searchInput) {
                const searchValue = searchInput.value;

                if (searchValue) {
                    const searchValues = searchValue.split(/[.,;\/ -]/);

                    for (let i = 0; i < searchItems.length; i++) {
                        const item = searchItems.item(i);
                        const title = item.querySelector('a:first-child');
                        const text = item.querySelector('p:nth-child(2)');

                        if (title) {
                            title.innerHTML = highlightText(title.textContent, searchValues);
                        }

                        if (text) {
                            text.innerHTML = highlightText(text.textContent, searchValues);
                        }
                    }

                    for (let i = 0; i < mediaTitleItems.length; i++) {
                        const mediaItem = mediaTitleItems.item(i);
                        mediaItem.innerHTML = highlightText(mediaItem.textContent, searchValues);
                    }
                }
            }
        }
    });
})(window, document, window.PageLoadedQueue);
